/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationFormDto,
  ProblemDetails,
} from '../models/index';
import {
    ApplicationFormDtoFromJSON,
    ApplicationFormDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface CreateTestDataApplicationFormRequest {
    organizationId: string;
}

/**
 * 
 */
export class TestDataApi extends runtime.BaseAPI {

    /**
     * Creates a test application form based on seeded data
     */
    async createTestDataApplicationFormRaw(requestParameters: CreateTestDataApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling createTestDataApplicationForm().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test-data/application-form`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Creates a test application form based on seeded data
     */
    async createTestDataApplicationForm(requestParameters: CreateTestDataApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.createTestDataApplicationFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
